export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";